import React, { useEffect, useState } from "react";
import { Accordion, Form, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import OverlayTooltip from "../_includes/OverlayTooltip";
import {
  hPlanCalculation,
  planData,
  toastError,
  toastSuccess,
  formatNumberToLocal,
  formatToCHF,
} from "../../helpers";
import { CURRENCIES } from "../../Constants";
// import heliorPlanTNCen from "../../assets/25_05_2026 EXCELIOR PLAN25 - ITA v1.pdf";
// import heliorPlanTNCit from "../../assets/25_05_2026 EXCELIOR PLAN25 - ITA v1.pdf";
// Update Multilingual Contract Docs ER38
import heliorPlanTNCit from "../../assets/01_NEG_X-PLAN_V6-A2_IT-um44bonpeiy1ujsf5nd1wb8uch.pdf";
import heliorPlanTNCen from "../../assets/02_NEG_X-PLAN_V6-A2_EN_ES_FR_PL-qkhtdmrwe7gozxfoqbfnuf7www.pdf";
import PdfViewer from "../PdfViewer";
import EosKey from "../EosKey";
import { useParams } from "react-router";
import SelectInput from "../SelectInput";

const HeliorPurchaseForm = ({
  purchaseData,
  setPurchaseData,
  resetPurchaseData,
  formData,
  setformData,
  eosKey,
  refetch,
  currency,
  setCurrency,
  rate,
  ratesData,
}) => {
  const { t } = useTranslation();
  const { lang } = useParams();
  const [error, setError] = useState({});

  const planFlags = [
    {
      name: "P01",
      code: "P01",
      title: t("xPlanTncFlags.P01.title"),
      text: t("xPlanTncFlags.P01.text", {
        language: lang === "it" ? "italiano" : "English",
        version: "V6-A2",
      }),
      reference: t("xPlanTncFlags.P01.reference"),
    },
    {
      name: "P02",
      code: "P02",
      title: t("xPlanTncFlags.P02.title"),
      text: t("xPlanTncFlags.P02.text"),
      reference: t("xPlanTncFlags.P02.reference"),
    },
    {
      name: "P03",
      code: "P03",
      title: t("xPlanTncFlags.P03.title"),
      text: t("xPlanTncFlags.P03.text"),
      reference: t("xPlanTncFlags.P03.reference"),
    },
    {
      name: "P04",
      code: "P04",
      title: t("xPlanTncFlags.P04.title"),
      text: t("xPlanTncFlags.P04.text"),
      reference: t("xPlanTncFlags.P04.reference"),
    },
    {
      name: "P05",
      code: "P05",
      title: t("xPlanTncFlags.P05.title"),
      text: t("xPlanTncFlags.P05.text"),
      reference: t("xPlanTncFlags.P05.reference"),
    },
    {
      name: "P06",
      code: "P06",
      title: t("xPlanTncFlags.P06.title"),
      text: t("xPlanTncFlags.P06.text"),
      reference: t("xPlanTncFlags.P06.reference"),
    },
    {
      name: "P07",
      code: "P07",
      title: t("xPlanTncFlags.P07.title"),
      text: t("xPlanTncFlags.P07.text"),
      reference: t("xPlanTncFlags.P07.reference"),
    },
    {
      name: "P08",
      code: "P08",
      title: t("xPlanTncFlags.P08.title"),
      text: t("xPlanTncFlags.P08.text"),
      reference: t("xPlanTncFlags.P08.reference"),
    },
    {
      name: "C01",
      code: "C01",
      title: t("xPlanTncFlags.C01.title"),
      text: t("xPlanTncFlags.C01.text"),
      reference: t("xPlanTncFlags.C01.reference"),
    },
    {
      name: "C02",
      code: "C02",
      title: t("xPlanTncFlags.C02.title"),
      text: t("xPlanTncFlags.C02.text"),
      reference: t("xPlanTncFlags.C02.reference"),
    },
    {
      name: "C03",
      code: "C03",
      title: t("xPlanTncFlags.C03.title"),
      text: t("xPlanTncFlags.C03.text"),
      reference: t("xPlanTncFlags.C03.reference"),
    },
  ];

  const blockchainFlags = [
    {
      name: "B01",
      code: "B01",
      title: t("xPlanTncFlags.blockchain_option.B01.title"),
      text: t("xPlanTncFlags.blockchain_option.B01.text", {
        language: lang === "it" ? "italiano" : "English",
        version: "V6-A2",
      }),
      reference: t("xPlanTncFlags.blockchain_option.B01.reference"),
    },
    {
      name: "B02P",
      code: "B02P",
      title: t("xPlanTncFlags.blockchain_option.B02P.title"),
      text: t("xPlanTncFlags.blockchain_option.B02P.text"),
      reference: t("xPlanTncFlags.blockchain_option.B02P.reference"),
      dependsOn: "B01",
    },
    {
      name: "B03",
      code: "B03",
      title: t("xPlanTncFlags.blockchain_option.B03.title"),
      text: t("xPlanTncFlags.blockchain_option.B03.text"),
      reference: t("xPlanTncFlags.blockchain_option.B03.reference"),
      dependsOn: "B01",
    },
  ];

  const handleChange = (e) => {
    const { name, value, checked } = e.target;
    setError({});
    switch (name) {
      case "periodicityOfPayment":
        const recurringAmountOptions = planData.filter(
          (item) => item.type === value,
        );
        setformData(recurringAmountOptions[0]);
        resetPurchaseData();
        setPurchaseData((prev) => ({
          ...prev,
          [name]: value,
        }));
        break;
      case "P01":
      case "P02":
      case "P03":
      case "P04":
      case "P05":
      case "P06":
      case "P07":
      case "P08":
      case "C01":
      case "C02":
      case "C03":
      case "B01":
      case "B02P":
      case "B03":
      case "acceptDOC":
      case "acceptPayment":
      case "acceptLimitation":
      case "acceptStorage":
      case "acceptToken":
      case "acceptTransaction":
      case "acceptServices":
      case "acceptTNC":
        setPurchaseData((prev) => {
          const updated = {
            ...prev,
            [name]: checked,
          };
          if (name === "P01") {
            updated.acceptTNC = checked;
          }
          if (name === "B01") {
            updated.acceptBlockchain = checked;
            if (!checked) {
              updated.B02P = false;
              updated.B03 = false;
            }
          }
          return updated;
        });
        break;
      case "docSplit":
        {
          const newData = { ...purchaseData, [name]: checked };
          const { message, ...result } = hPlanCalculation(newData);
          if (message.type === "error") {
            toastError("", t(message.text));
          }
          if (message.type === "success") {
            toastSuccess(t(message.text));
          }
          setPurchaseData(result);
        }
        break;
      case "paymentMethod":
        const newData = { ...purchaseData, [name]: value };
        const result = hPlanCalculation(newData);
        if (value === "Credit Card") {
          setCurrency("CHF");
          const newResult = hPlanCalculation({
            ...result,
            recurringPaymentAmount: formatToCHF(
              formData?.recurringAmount?.[0] ?? "",
              1,
            ),
          });
          setPurchaseData(newResult);
        } else {
          setPurchaseData(result);
        }
        break;
      default:
        {
          const newData = { ...purchaseData, [name]: value };
          const { message, ...result } = hPlanCalculation(newData);
          setPurchaseData(result);
        }
        break;
    }
  };

  const handleCurrencyChange = (e) => {
    const newCurrency = e.target.value;
    if (newCurrency !== "CHF" && purchaseData.paymentMethod === "Credit Card") {
      purchaseData.paymentMethod = "";
    }
    const newRate =
      newCurrency !== "CHF" && ratesData?.data?.[newCurrency]
        ? ratesData.data[newCurrency]
        : 1;
    setCurrency(newCurrency);
    const { message, ...result } = hPlanCalculation({
      ...purchaseData,
      recurringPaymentAmount: formatToCHF(
        formData?.recurringAmount?.[0] ?? "",
        newRate,
      ),
    });
    setPurchaseData(result);
  };

  useEffect(() => {
    if (purchaseData.periodicityOfPayment) {
      const recurringAmountOptions = planData.filter(
        (item) => item.type === purchaseData.periodicityOfPayment,
      );
      setformData(recurringAmountOptions[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [purchaseData]);

  const fileToDisplay = lang === "en" ? heliorPlanTNCen : heliorPlanTNCit;

  const periodicityOptions = [
    { value: "Monthly", label: t("monthly") },
    { value: "Bimonthly", label: t("bimonthly") },
    { value: "Quarterly", label: t("quarterly") },
  ];

  const recurringAmountOptions =
    formData?.recurringAmount?.map((value) => ({
      value: formatToCHF(value, rate),
      label: formatNumberToLocal(value),
    })) || [];

  const ingotOptions = [50, 100, 250, 500, 1000].map((weight) => ({
    value: weight,
    label: `${weight}gr`,
  }));

  const currencyOptions = CURRENCIES.map((c) => ({ value: c, label: c }));

  const paymentMethodOptions = [
    { value: "Wire Transfer", label: t("wireTransfer") },
    ...(currency === "CHF"
      ? [{ value: "Credit Card", label: t("creditCard") }]
      : []),
    { value: "Usdt Tron", label: `USDT ${t("on")} Tron` },
    { value: "Usdt Polygon", label: `USDC ${t("on")} Polygon` },
    { value: "Bitcoin", label: `Bitcoin ${t("on")} Bitcoin` },
    { value: "Ethereum", label: `Ethereum ${t("on")} Ethereum` },
  ];

  const renderFlagItem = (flag, isDisabled = false) => {
    const titleDisplay = flag.title?.startsWith(flag.code)
      ? flag.title
      : `${flag.code} \u2013 ${flag.title}`;

    return (
      <Form.Check
        key={flag.name}
        className="d-flex align-items-start mb-2"
        type="checkbox"
        name={flag.name}
        id={`plan-term-${flag.name}`}
        disabled={isDisabled}
        checked={!!purchaseData[flag.name] && !isDisabled}
        onChange={handleChange}
        label={
          <div style={{ opacity: isDisabled ? 0.45 : 1 }}>
            <div
              className="fw-semibold"
              style={{ fontSize: "0.84rem", color: "#e4e6eb", lineHeight: 1.25 }}
            >
              {titleDisplay}
              {flag.reference && (
                <span
                  className="fst-italic px-1"
                  style={{ fontSize: "0.72rem", color: "#737a85" }}
                >
                  {flag.reference}
                </span>
              )}
            </div>
            <div
              className="mt-1"
              style={{ fontSize: "0.78rem", color: "#a6adb7", lineHeight: 1.35 }}
            >
              {flag.customText || flag.text}
            </div>
          </div>
        }
      />
    );
  };

  return (
    <Accordion className="purchase-page" defaultActiveKey="0">
      <Accordion.Item eventKey="0">
        <Accordion.Header>
          <small>Step 1</small>
          <span>{t("storagePlan")}</span>
        </Accordion.Header>
        <Accordion.Body>
          <Row>
            <Form.Group as={Col} xs={12} md={6} className="mb-3">
              <Form.Label>{t("paymentPeriodicity")}</Form.Label>
              <SelectInput
                name="periodicityOfPayment"
                options={periodicityOptions}
                value={purchaseData.periodicityOfPayment}
                onChange={handleChange}
                placeholder={t("select")}
              />
            </Form.Group>
            <Form.Group as={Col} xs={12} md={6} className="mb-3">
              <Form.Label>{t("amountOfRecurringPayments")}</Form.Label>
              <SelectInput
                name="recurringPaymentAmount"
                options={recurringAmountOptions}
                value={purchaseData.recurringPaymentAmount}
                onChange={handleChange}
                placeholder={t("select")}
              />
            </Form.Group>
          </Row>
          <Row>
            <Form.Group as={Col} xs={12} md={6} className="mb-3">
              <Form.Label className="d-flex justify-content-between">
                {t("numberOfRecurringPayments")}
                {purchaseData.periodicityOfPayment && (
                  <OverlayTooltip
                    text={`${t("minRecurringNumberMsg")} ${formData?.minRecurringPaymentNumber
                      } ${t("and")} ${formData?.maxRecurringPaymentNumber}`}
                  />
                )}
              </Form.Label>
              <Form.Control
                type="number"
                name="recurringPaymentNumber"
                min={formData?.minRecurringPaymentNumber}
                max={formData?.maxRecurringPaymentNumber}
                onChange={(e) => handleChange(e)}
                value={purchaseData.recurringPaymentNumber}
                isInvalid={error?.recurringPaymentNumber}
              />
              <Form.Control.Feedback type="invalid">
                {error.recurringPaymentNumber}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} xs={12} md={6} className="mb-3">
              <Form.Label>{t("numberOfInitialPayments")}</Form.Label>
              <Form.Control
                type="number"
                name="initialPaymentNumber"
                min={1}
                max={purchaseData.recurringPaymentNumber - 1}
                value={purchaseData.initialPaymentNumber}
                onChange={(e) => handleChange(e)}
                isInvalid={error?.initialPaymentNumber}
              />
              <Form.Control.Feedback type="invalid">
                {error.initialPaymentNumber}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Form.Group className="mb-3">
            <Form.Label>{t("ingotCutting")}</Form.Label>
            <SelectInput
              name="ingot"
              options={ingotOptions}
              value={purchaseData.ingot}
              onChange={handleChange}
              placeholder={t("select")}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>{t("currency")}</Form.Label>
            <SelectInput
              name="currency"
              options={currencyOptions}
              value={currency}
              onChange={handleCurrencyChange}
              placeholder={t("select")}
            />
          </Form.Group>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="1">
        <Accordion.Header>
          <small>Step 2</small>
          <span>{t("termsAndConditions")}</span>
        </Accordion.Header>
        <Accordion.Body>
          <PdfViewer file={fileToDisplay} />
          <div className="mt-3">
            {planFlags.map((flag) => renderFlagItem(flag))}
          </div>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="2">
        <Accordion.Header>
          <small>Step 3</small>
          <span>{t("paymentMethod")}</span>
        </Accordion.Header>
        <Accordion.Body>
          <SelectInput
            name="paymentMethod"
            options={paymentMethodOptions}
            value={purchaseData.paymentMethod}
            onChange={handleChange}
            placeholder={t("select")}
          />
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="3">
        <Accordion.Header>
          <small>Step 4</small>
          <span>{t("downloadEosKey")}</span>
        </Accordion.Header>
        <Accordion.Body>
          <div className="mb-2">
            {!eosKey?.isAvailable && (
              <div className="my-3 pt-3 border-top border-secondary">
                <EosKey refetch={refetch} />
              </div>
            )}
            {blockchainFlags.map((flag) => {
              const isDisabled = flag.dependsOn && !purchaseData[flag.dependsOn];
              return renderFlagItem(flag, isDisabled);
            })}
          </div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default HeliorPurchaseForm;
